var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_9732",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 0H0V35H36.1667V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2487 0H9.91536C4.7607 0 0.582031 4.17867 0.582031 9.33333V25.6667C0.582031 30.8213 4.7607 35 9.91536 35H26.2487C31.4034 35 35.582 30.8213 35.582 25.6667V9.33333C35.582 4.17867 31.4034 0 26.2487 0Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2493 0.583984H9.91602C5.08352 0.583984 1.16602 4.50149 1.16602 9.33398V25.6673C1.16602 30.4998 5.08352 34.4173 9.91602 34.4173H26.2493C31.0818 34.4173 34.9993 30.4998 34.9993 25.6673V9.33398C34.9993 4.50149 31.0818 0.583984 26.2493 0.583984Z",
    stroke: "white",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_459_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6001 11.048C26.8861 11.3612 26.1253 11.5688 25.3321 11.6696C26.1481 11.1824 26.7709 10.4168 27.0637 9.49397C26.3029 9.94757 25.4629 10.268 24.5677 10.4468C23.8453 9.67757 22.8157 9.20117 21.6925 9.20117C19.5133 9.20117 17.7589 10.97 17.7589 13.1384C17.7589 13.4504 17.7853 13.7504 17.8501 14.036C14.5777 13.8764 11.6821 12.308 9.73695 9.91877C9.39735 10.508 9.19815 11.1824 9.19815 11.9084C9.19815 13.2716 9.90015 14.48 10.9465 15.1796C10.3141 15.1676 9.69375 14.984 9.16815 14.6948V14.738C9.16815 16.6508 10.5325 18.2396 12.3217 18.6056C12.0013 18.6932 11.6521 18.7352 11.2897 18.7352C11.0377 18.7352 10.7833 18.7208 10.5445 18.668C11.0545 20.2268 12.5017 21.3728 14.2225 21.41C12.8833 22.4576 11.1829 23.0888 9.34215 23.0888C9.01935 23.0888 8.70975 23.0744 8.40015 23.0348C10.1437 24.1592 12.2101 24.8012 14.4385 24.8012C21.6817 24.8012 25.6417 18.8012 25.6417 13.6004C25.6417 13.4264 25.6357 13.2584 25.6273 13.0916C26.4085 12.5372 27.0649 11.8448 27.6001 11.048Z",
    fill: "#B3B3B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_459_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(8.40039 7.40039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterNav);
export default __webpack_public_path__ + "static/media/twitterNav.2e0962f7b96b24ba5c43e5de0cbaa2ed.svg";
export { ForwardRef as ReactComponent };